import { 
  Bot, 
  TrendingUp, 
  Sparkles, 
  Eye, 
  Shield, 
  Clock 
} from "lucide-react";
import AnimateOnScroll from "./AnimateOnScroll";

const features = [
  {
    icon: Bot,
    title: "Autonomous agent",
    description: "Set a goal and the agent builds the strategy: segments, campaigns, widgets, and journeys — all automatically.",
  },
  {
    icon: Sparkles,
    title: "Dynamic AI copy",
    description: "Every visitor sees personalized text generated in real-time based on their profile, source, and behavior.",
  },
  {
    icon: TrendingUp,
    title: "Self-optimizing campaigns",
    description: "The agent monitors performance 24/7. Low CTR? It generates variants, runs A/B tests, and picks winners.",
  },
  {
    icon: Eye,
    title: "Proactive insights",
    description: "Get actionable recommendations: 'Mobile bounce rate is high — I've prepared a banner. Want to activate it?'",
  },
  {
    icon: Shield,
    title: "You stay in control",
    description: "Choose full autonomy, supervised mode, or manual-only. Set rules, limits, and blocked pages.",
  },
  {
    icon: Clock,
    title: "Live in 5 minutes",
    description: "Add one script, set your goal, and the agent starts working. No developers, no complex setup.",
  }
];

const Features = () => {
  return (
    <section id="features" className="py-24 bg-background" aria-labelledby="features-heading">
      <div className="container mx-auto px-4">
        {/* Header */}
        <AnimateOnScroll>
          <header className="text-center max-w-2xl mx-auto mb-16">
            <h2 id="features-heading" className="text-3xl md:text-4xl font-semibold text-foreground mb-4 tracking-tight">
              What your AI agent does for you
            </h2>
            <p className="text-lg text-muted-foreground">
              It doesn't just suggest — it executes, monitors, and improves.
            </p>
          </header>
        </AnimateOnScroll>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <AnimateOnScroll key={index} delay={index * 100}>
              <article 
                className="group p-6 rounded-2xl border border-transparent hover:border-border hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="inline-flex p-3 rounded-xl bg-muted mb-4 group-hover:scale-110 transition-transform duration-300">
                  <feature.icon className="w-5 h-5 text-foreground" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </article>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
